import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

/**
 * Protege a rota de cadastro de servidor exigindo uma senha de acesso.
 * Uma vez informada corretamente, fica liberada até o fim da sessão do navegador.
 */
@Injectable({
  providedIn: 'root'
})
export class SenhaCadastroServidorGuard implements CanActivate {

  private readonly SENHA = 'wellne12';
  private readonly CHAVE_SESSAO = 'acesso_cadastro_servidor';

  constructor(private router: Router) { }

  canActivate(): boolean {
    // já autenticado nesta sessão
    if (sessionStorage.getItem(this.CHAVE_SESSAO) === 'ok') {
      return true;
    }

    const informada = window.prompt('Informe a senha de acesso ao cadastro de servidor:');

    if (informada === this.SENHA) {
      sessionStorage.setItem(this.CHAVE_SESSAO, 'ok');
      return true;
    }

    // senha incorreta ou cancelada: bloqueia e redireciona
    if (informada !== null) {
      window.alert('Senha incorreta.');
    }
    this.router.navigate(['']);
    return false;
  }
}
